import React, { useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import EbookLP2 from "../../components/ebooklp2";
import BgImg1 from "../../../images/locationgcc/dxb/ae/ebook-bg.webp";
import { StaticImage } from "gatsby-plugin-image";

const EbookLanding = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <section
        className="p-100 ebook_lp_secion"
        style={{ backgroundImage: `url(${BgImg1})` }}
      >
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
              <div className="example dark_bg_text" data-text="المرحلة التالية">
                <h4>Take Your Business to The Next Level</h4>
              </div>
              <p>
                Discover the secrets to scaling your brand. We’re talking about
                the essentials that should define your digital presence. Whether
                you're a startup or an enterprise, this eBook is your blueprint
                for upscaling through web development – driving exponential
                business growth.
              </p>
              <div
                className="btn_download"
                onClick={handleShow}
                style={{ background: "rgb(240, 121, 45)" }}
              >
                GET MY COPY
              </div>
            </Col>
            <Col
              xs={12}
              md={6}
              lg={7}
              xl={7}
              xxl={7}
              className="my-auto text-center"
            >
              <StaticImage
                src="../../../images/locationgcc/dxb/ae/ebook_img.webp"
                alt="mobile app development company"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={766}
                height={679}
              />
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="modal_forms">
          <EbookLP2 setShow={setShow} GCC="yes" />
        </div>
      </Modal>
    </>
  );
};

export default EbookLanding;
